import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";
import hasRightForPath from "modules/roles/helpers/hasRightForPath";
import { Verb } from "modules/roles/schemas/rolesSchemas";

export function useHasAccessRights(path: string, verbs?: Verb[]) {
  const { data: roles } = useSelfcare(false);
  return roles && hasRightForPath(path, roles.routes, verbs);
}
